import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

const MLogOut = gql`
    mutation MLogOut ($idUsuario: Int!) {
        logOut(idUsuario: $idUsuario)
    }`;

export const useLogout = () => {
  const [logOutMutation] = useMutation(MLogOut);

  const logout = async () => {
    const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

    if (idUsuario) {
      try {
        await logOutMutation({ variables: { idUsuario: idUsuario } });
      } catch {
        // no bloquear el cierre de sesión si falla el registro del logout
      }
    }
  };

  return logout;
};
